import React from 'react';
import { BCMSDate, DisabledPrompt } from "@bcm-dev/bcms-vite";
import { SVGAsset } from 'res';
import './styles.css';

export default function MonthTabsContainer(props) {
  const className = props.className ?? "";
  const months = [];

  // Create an array of the last 6 months.
  for(let i = 0; i < 6; i++) {
    const curr = BCMSDate.init().setToFirst().offset([0, (i * -1), 0]).format('M');
    months.push(curr);
  }

  return(
    <div className={className + " month-tabs-container flex-container flex-horizontal align-center-container"}>
      <DisabledPrompt>
        <div className="month-tab-item flex-width clickable text-center">
          <SVGAsset id="LeftChevronIcon" />
        </div>
      </DisabledPrompt>
      <MonthTabItem text={months[5]} />
      <MonthTabItem text={months[4]} />
      <MonthTabItem text={months[3]} />
      <MonthTabItem text={months[2]} />
      <MonthTabItem text={months[1]} />
      <MonthTabItem activeClass="active-month-tab"  text={months[0]} />
      <div className="month-tab-item flex-width" />
    </div>
  );
}

export function MonthTabItem(props) {
  const activeClass = props.activeClass ?? "";
  const text = props.text ?? "[Tab Text]";

  return(
    <DisabledPrompt>
      <div className={activeClass + " month-tab-item flex-width text-center clickable"}>
        <span className="month-tab-text">{text}</span>
      </div>
    </DisabledPrompt>
  );
}